module.exports = __webpack_public_path__ + "img/xc.7190fbe1.jpg";